import { httpConsulta } from "../../../../services/apiManagement/Http.interceptor";
import { httpConsultaGenerica } from "../../../../services/apiGeneric/Http.interceptor";


export const getParticularity = (data:string) => {
    return httpConsulta.get(`/getParticularidadeDocaByCd?cd=${data}`);
}

export const postParticularity = (data:Object) => {
    return httpConsulta.post(`/insertParticularidadeDoca`, data);
}

export const getDoca = (data: string) => {
    return httpConsulta.get(`/getDocaByCd?cd=${data}`);
}

export const putParticularity = (data: Object) => {
    return httpConsulta.post(`/updateParticularidadeDoca`, data)
}